import { CalculatorSectionVariant } from 'src/features/homeowners/components/calculator-section/calculator-section-variant';

export function CalculatorSection(): JSX.Element {
  return (
    <div className="container">
      <CalculatorSectionVariant />
    </div>
  );
}
